/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
console.log("Hello World! (from create-block-tdee-calculator block)");
/* eslint-enable no-console */

// --- Helper Function for Number Formatting ---
function formatNumberWithCommas(num) {
    if (isNaN(num)) return num;
    return Math.round(num).toLocaleString('en-US');
}

function calculateTDEE(weightKg, heightCm, ageYears, gender, activityLevel) {
	let bmr = (10 * weightKg) + (6.25 * heightCm) - (5 * ageYears);
	gender.toLowerCase() === 'male' ? bmr += 5 : bmr -= 161;

	const activityMultipliers = {
     	'sedentary': 1.2,
     	'lightly active': 1.375,
     	'moderately active': 1.55,
     	'very active': 1.725,
     	'extra active': 1.9
    	};

    	const multiplier = activityMultipliers[activityLevel.toLowerCase()];
    	if (multiplier) return bmr * multiplier;
    	throw new Error("Invalid activity level provided.");
}

// --- UI Update Function ---
function updateAllDisplayElements(results) {
	document.querySelectorAll(".calc-tdee").forEach(el => el.textContent = formatNumberWithCommas(results.tdee));
	document.querySelectorAll(".calc-calories-1lb").forEach(el => el.textContent = formatNumberWithCommas(results.calories1lb));
	document.querySelectorAll(".calc-calories-2lb").forEach(el => el.textContent = formatNumberWithCommas(results.calories2lb));
	document.querySelectorAll(".calc-cal").forEach(el => el.style.display = 'inline-block');
	document.querySelector(".disclaimer2").style.display = 'block';
	document.querySelector(".get-started-button").style.display = 'block';
}

// --- Main Logic ---
document.addEventListener("DOMContentLoaded", () => {

	const form = document.getElementById("tdeeForm");

	const heightFeetInput = document.getElementById("heightFeet");
	const heightInchesInput = document.getElementById("heightInches");
	const weightInput = document.getElementById("weight");
	const ageInput = document.getElementById("age");
	const activityLevelInput = document.getElementById("activityLevel");
	const sexInput = document.querySelectorAll("input[name=sex]");
	let sX = 'female';

	sexInput.forEach(radio => {
		radio.addEventListener('change', function() {
			sX = this.value;
		});
	});

	form.addEventListener("submit", (event) => {
		event.preventDefault();

     	const hF = parseFloat(heightFeetInput.value), hI = parseFloat(heightInchesInput.value), cW = parseFloat(weightInput.value), aG = parseFloat(ageInput.value), aL = activityLevelInput.value;

		if ( isNaN(hF) || isNaN(hI) || isNaN(aG) || !cW || !aL ) {
			// showToast("Please fill in all fields to unlock your personalized plan.");
			return;
		}

		try {
			const tdee = calculateTDEE(cW * 0.453592, ((hF * 12) + hI) * 2.54, aG, sX, aL);
        		const cal1 = tdee - 500;
        		const cal2 = tdee - 1000;

			updateAllDisplayElements({ tdee, calories1lb: cal1, calories2lb: cal2 });

		} catch (e) {
			console.error(e);
			// showToast("Error processing plan. Please check inputs.");
		}
	});

});